import { Box, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import OujatImage from 'src/assets/images/Oujat.png'
import LanguageDropdown from 'src/@core/layouts/components/shared-components/LanguageDropdown'
import { useSettings } from 'src/@core/hooks/useSettings'

/** Minimal shell for website-origin guest open-request wizard (no sidebar / account chrome). */
const GuestQmsLayout = ({ children }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { settings, saveSettings } = useSettings()

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fff', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: { xs: 3, md: 6 },
          py: 2.5,
          borderBottom: '1px solid #EAECF0'
        }}
      >
        <Box component='img' src={OujatImage} alt='OUJAT' sx={{ height: 32 }} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <LanguageDropdown settings={settings} saveSettings={saveSettings} />
          <Button variant='outlined' onClick={() => navigate('/login')} sx={{ fontWeight: 700 }}>
            {t('Login', 'Login')}
          </Button>
        </Box>
      </Box>
      <Box sx={{ flex: 1, px: { xs: 3, md: 6 }, py: { xs: 3, md: 4 } }}>{children}</Box>
    </Box>
  )
}

export default GuestQmsLayout
